import { render } from "./CommentSvgIcon.vue?vue&type=template&id=2adba220"
import script from "./CommentSvgIcon.vue?vue&type=script&lang=js"
export * from "./CommentSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__